
(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:RegulationDetailsCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('paxMsgDetailsCtrl', paxMsgDetailsCtrl);

    function paxMsgDetailsCtrl(modalParams,$uibModalInstance,PaxMessageService,MessageService) {
        var vm = this;

        vm.model = {
            paxMsgDet : modalParams.data
        };

        vm.onConfirmClick = function () {
            $uibModalInstance.close(modalParams.onAcceptPassBackParam);
        };
        
        vm.onResubmit = function(pax){
        	var data = [];
        	data.paxMsgCrew =[];
        	var paxcrew = [];
        	paxcrew.paxMsgJourneyCrewId = pax.paxMsgJourneyCrewId;
        	paxcrew.isSelected = true;	
        	data.paxMsgSchdId = pax.paxMsgSchdId;
        	data.paxMsgCrew.push(paxcrew);
        	
        	var reSubmit = PaxMessageService.setResubmitData(data);
			PaxMessageService.reSubmit(function() {
				MessageService.success('Successfully Submitted!!');
				$uibModalInstance.close(modalParams.onAcceptPassBackParam);
			}, function(error) {
				MessageService.error(error);
			});
        	
        };
    }
}());